<template>
  <div class="flex-fill">
    <!-- Error title -->
    <div class="text-center mb-3" style="padding-top:150px">
      <h1 class="error-title">Oops!</h1>
      <h5 v-if="msg">{{msg}}</h5>
      <h5 v-else>We can't seem to find the page you are looking for.</h5>
      <h5><router-link to="/Inbox">Go To Home</router-link></h5>
    </div>
    <!-- /error title -->
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  name: 'NotFound',
  computed:{
    msg(){
      
      return this.$route.query.msg;
    }
  },
  watch:{
    
  }
}
</script>
